import React from "react";
import Auth from "@rill/auth";
import submit from "submit-form";
import LoginPasswordView from "./login-password";
import LoginCodeView from "./login-code";
import SignupPasswordView from "./signup-password";
import LoginProfileView from "./login-profile";
import SignupDetailsView from "./signup-details";
import SignupParqView from "./signup-parq";
import SignupParq2View from "./signup-parq2";
import UnknownUserView from "./unknown-user";
import LoginWrapper from "./LoginWrapper";

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      email: "",
      password: "",
      passwordSignup: "",
      confirmPasswordSignup: "",
      firstName: "",
      lastName: "",
      units: "metric",
      bodyWeight: null,
      repMaxSquat: null,
      repMaxBench: null,
      repMaxDeadlift: null,
      repMaxClean: null,
      repMaxJerk: null,
      repMaxSnatch: null,
      repMaxOverheadPress: null,
      agreeTOS: null,
      avatar: "",
      heartCondition: null,
      chestPain: null,
      pastMonthChestPain: null,
      dizzinesConsciousnessLoss: null,
      boneJointProblem: null,
      bloodPressurePrescription: null,
      reasonForNoPhysicalAct: null,
      code: "",
      step: 0,
      token: "",
      userId: null,
      reset: false,
    };
    this.getEmailFilled = this.getEmailFilled.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleEmailButton = this.handleEmailButton.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordLogin = this.handlePasswordLogin.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.submitVerificationCode = this.submitVerificationCode.bind(this);
    this.resendVerificationCode = this.resendVerificationCode.bind(this);
    this.handleSignupPwd = this.handleSignupPwd.bind(this);
    this.submitUserName = this.submitUserName.bind(this);
    this.handleUserDetails = this.handleUserDetails.bind(this);
    this.handleParqInfo = this.handleParqInfo.bind(this);
    this.onFinishRegister = this.onFinishRegister.bind(this);
    this.getUserStatus = this.getUserStatus.bind(this);
    this.onUnknownUserBack = this.onUnknownUserBack.bind(this);
    this.setStep = this.setStep.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { query } = this.context.locals;
    const resetState = {
      email: "",
      password: "",
      passwordSignup: "",
      confirmPasswordSignup: "",
      firstName: "",
      lastName: "",
      units: "metric",
      bodyWeight: 0,
      repMaxSquat: 0,
      repMaxBench: 0,
      repMaxDeadlift: 0,
      repMaxClean: 0,
      repMaxJerk: 0,
      repMaxSnatch: 0,
      repMaxOverheadPress: 0,
      agreeTOS: null,
      avatar: "",
      heartCondition: null,
      chestPain: null,
      pastMonthChestPain: null,
      dizzinesConsciousnessLoss: null,
      boneJointProblem: null,
      bloodPressurePrescription: null,
      reasonForNoPhysicalAct: null,
      code: "",
      step: 0,
      token: "",
      userId: null,
      reset: true,
    };
    if (query.reset && !this.state.reset) {
      this.setState(resetState);
      submit("/login-refresh", {
        method: "POST",
        body: {},
      });
      return;
    }
    const reset = false;
    if (query.step !== this.state.step) {
      if (query.step === 0) {
        // if the user goes back to the step 0, the state info is reset except for the email
        this.setState(Object.assign(resetState, { email: this.state.email }));
      }
      if (query.step < 4) {
        // forget password & information that might be on state when going back
        this.setState({
          step: query.step,
          reset,
          password: "",
          passwordSignup: "",
          confirmPasswordSignup: "",
        });
      } else if (
        query.step === 4 &&
        this.state.passwordSignup &&
        this.state.confirmPasswordSignup
      ) {
        this.setState({ step: 4, reset });
      } else if (
        query.step === 5 &&
        this.state.firstName &&
        this.state.lastName
      ) {
        this.setState({ step: 5, reset, agreeTOS: null });
      } else if (query.step === 6) {
        this.setState({ step: 6, reset });
      } else if (query.step === 7) {
        this.setState({ step: 7, reset });
      } else if (query.step === 8) {
        this.setState({ step: 8, reset });
      }
    }
    // reseting the state
    if (!(query.step || query.reset)) {
      if (this.state.reset === prevState.reset && !prevState.reset) {
        return;
      }
      this.setState({
        email: null,
        password: "",
        passwordSignup: "",
        confirmPasswordSignup: "",
        firstName: "",
        lastName: "",
        units: "metric",
        bodyWeight: 0,
        repMaxSquat: 0,
        repMaxBench: 0,
        repMaxDeadlift: 0,
        repMaxClean: 0,
        repMaxJerk: 0,
        repMaxSnatch: 0,
        repMaxOverheadPress: 0,
        agreeTOS: null,
        avatar: "",
        heartCondition: null,
        chestPain: null,
        pastMonthChestPain: null,
        dizzinesConsciousnessLoss: null,
        boneJointProblem: null,
        bloodPressurePrescription: null,
        reasonForNoPhysicalAct: null,
        code: "",
        step: 0,
        token: "",
        userId: null,
        reset: false,
      });
    }
  }

  getEmailFilled() {
    return this.state.email;
  }

  handleEmailChange(event) {
    const email = event.target.value;
    this.setState({ email: email });
  }

  handlePasswordChange(event) {
    const password = event.target.value;
    this.setState({ password: password });
  }

  cleanNumber({ target }) {
    const numberReg = /-?(\d+(\.\d*)?)?/;
    const notNumberReg = /[^-\.0-9]/g;
    if (target.value === "" || target.value == null) return "";
    const value = target.value.replace(notNumberReg, "");
    let match = (value.match(numberReg) || [""])[0];
    if (match) {
      match = match.slice(0, 4);
    }

    return match;
  }

  handleFieldChange(event) {
    const target = event.target || event;
    // event.preventDefault();
    if (target.name === "code") {
      var inputLength = target.value.length;
      if (inputLength > 4) return;
      // this.cleanNumber(event);
      const tempValue = this.cleanNumber(event);
      // target.value.slice(0, 4);
      target.value = "";
      target.value = tempValue;
    } else if (target.name === "agreeTOS") {
      if (this.state.agreeTOS) {
        this.setState({ agreeTOS: null });
      } else {
        this.setState({ agreeTOS: "on" });
      }
      return;
    } else if (target.name === "avatar") {
      this.setState({ [target.name]: target.files[0] || "" });
      return;
    }
    this.setState({ [target.name]: target.value });
  }

  handlePasswordLogin(event) {
    event.preventDefault();
    const { email, password } = this.state;
    submit(`/login`, {
      method: "POST",
      body: { email, password },
    });
  }

  getUserStatus() {
    const { email } = this.state;
    submit(`/user-status/${email}`, {
      method: "GET",
    });
  }

  async handleEmailButton(event) {
    event.preventDefault();
    // we need to make sure the email is lower case before submitting
    const lowerCaseEmail = this.state?.email?.toLowerCase();
    this.setState({ email: lowerCaseEmail }, () => this.getUserStatus());
  }

  submitVerificationCode(e) {
    const { email, code } = this.state;
    const { query } = this.context.locals;
    const { organizationId = "" } = query;
    e.preventDefault();
    submit("/submit-code", {
      method: "POST",
      body: {
        email: email,
        confirmCode: code,
        organizationId,
      },
    });
  }

  resendVerificationCode(event) {
    event.preventDefault();
    const { email } = this.state;
    submit("/resend-code", {
      method: "POST",
      body: {
        email,
      },
    });
  }

  async handleSignupPwd(event) {
    event.preventDefault();
    const { passwordSignup, confirmPasswordSignup } = this.state;
    submit("/set-password", {
      method: "POST",
      body: {
        password: passwordSignup,
        confirmPassword: confirmPasswordSignup,
      },
    });
  }

  async submitUserName(event) {
    event.preventDefault();
    const { firstName, lastName, avatar } = this.state;
    const body = {
      first_name: firstName,
      last_name: lastName,
      avatar,
    };
    submit("/user-names", {
      method: "POST",
      body,
    });
  }

  handleUserDetails(event) {
    event.preventDefault();
    const {
      units,
      bodyWeight,
      repMaxSquat,
      repMaxBench,
      repMaxDeadlift,
      repMaxClean,
      repMaxJerk,
      repMaxSnatch,
      repMaxOverheadPress,
      agreeTOS,
    } = this.state;
    const body = {
      units,
      bodyWeight,
      repMaxSquat,
      repMaxBench,
      repMaxDeadlift,
      repMaxClean,
      repMaxJerk,
      repMaxSnatch,
      repMaxOverheadPress,
      agreeTOS,
    };

    submit("/user-details", {
      method: "POST",
      body,
    });
  }

  handleParqInfo(event) {
    event.preventDefault();
    const {
      heartCondition,
      chestPain,
      pastMonthChestPain,
      dizzinesConsciousnessLoss,
      boneJointProblem,
      bloodPressurePrescription,
      reasonForNoPhysicalAct,
    } = this.state;
    const body = {
      heartCondition,
      chestPain,
      pastMonthChestPain,
      dizzinesConsciousnessLoss,
      boneJointProblem,
      bloodPressurePrescription,
      reasonForNoPhysicalAct,
    };

    submit("/user-parq", {
      method: "POST",
      body,
    });
  }

  // Actually not using this function to submit
  onFinishRegister(event) {
    event.preventDefault();
    const {
      agreeTOS,
      avatar,
      email,
      repMaxBench,
      repMaxDeadlift,
      repMaxSquat,
      passwordSignup,
      confirmPasswordSignup,
      code,
      firstName,
      lastName,
      units,
      bodyWeight,
      bloodPressurePrescription,
      boneJointProblem,
      chestPain,
      dizzinesConsciousnessLoss,
      heartCondition,
      pastMonthChestPain,
      reasonForNoPhysicalAct,
    } = this.state;

    const body = {
      agreeTOS,
      avatar,
      email,
      repMaxBench,
      repMaxDeadlift,
      repMaxSquat,
      passwordSignup,
      confirmPasswordSignup,
      code,
      firstName,
      lastName,
      units,
      bodyWeight,
      bloodPressurePrescription,
      boneJointProblem,
      chestPain,
      dizzinesConsciousnessLoss,
      heartCondition,
      pastMonthChestPain,
      reasonForNoPhysicalAct,
    };
    submit("/finish-onboarding", {
      method: "POST",
      body,
    });
  }

  onUnknownUserBack(event) {
    event.preventDefault();
    submit("/new-signup", {
      method: "POST",
      body: {},
    });
  }

  /** Used by children to got to previous step */
  setStep(step) {
    const url = `/login-new-onboarding/redirect/${step}`;
    submit(url, {
      method: "GET",
    });
  }

  render() {
    const { step, email } = this.state;
    const { query } = this.context.locals;
    const { redirect } = query;

    let renderingComponent = null;

    if (step === 0) {
      renderingComponent = (
        <LoginEmailView
          email={email}
          getEmailFilled={this.getEmailFilled}
          handleEmailChange={this.handleEmailChange}
          handleEmailButton={this.handleEmailButton}
          redirect={redirect}
        />
      );
    } else if (step === 1 && email) {
      renderingComponent = (
        <LoginPasswordView
          handlePasswordLogin={this.handlePasswordLogin}
          handlePasswordChange={this.handlePasswordChange}
          email={email}
          handleEmailChange={this.handleEmailChange}
          onBack={this.setStep}
        />
      );
    } else if (step === 2) {
      renderingComponent = (
        <LoginCodeView
          onBack={this.setStep}
          handleFieldChange={this.handleFieldChange}
          submitVerificationCode={this.submitVerificationCode}
          resendVerificationCode={this.resendVerificationCode}
          email={email}
          codeValue={this.state.code}
        />
      );
    } else if (step === 3) {
      renderingComponent = (
        <SignupPasswordView
          onBack={this.setStep}
          handleFieldChange={this.handleFieldChange}
          handleSignupPwd={this.handleSignupPwd}
        />
      );
    } else if (step === 4) {
      renderingComponent = (
        <LoginProfileView
          onBack={this.setStep}
          firstName={this.state.firstName}
          lastName={this.state.lastName}
          handleFieldChange={this.handleFieldChange}
          submitUserName={this.submitUserName}
        />
      );
    } else if (step === 5) {
      renderingComponent = (
        <SignupDetailsView
          onBack={this.setStep}
          units={this.state.units}
          bodyWeight={this.state.bodyWeight}
          repMaxSquat={this.state.repMaxSquat}
          repMaxBench={this.state.repMaxBench}
          repMaxDeadlift={this.state.repMaxDeadlift}
          repMaxClean={this.state.repMaxClean}
          repMaxJerk={this.state.repMaxJerk}
          repMaxSnatch={this.state.repMaxSnatch}
          repMaxOverheadPress={this.state.repMaxOverheadPress}
          handleFieldChange={this.handleFieldChange}
          handleUserDetails={this.handleUserDetails}
          locals={this.props.locals}
        />
      );
    } else if (step === 6) {
      renderingComponent = (
        <SignupParqView
          onBack={this.setStep}
          heartCondition={this.state.heartCondition}
          chestPain={this.state.chestPain}
          pastMonthChestPain={this.state.pastMonthChestPain}
          dizzinesConsciousnessLoss={this.state.dizzinesConsciousnessLoss}
          boneJointProblem={this.state.boneJointProblem}
          bloodPressurePrescription={this.state.bloodPressurePrescription}
          reasonForNoPhysicalAct={this.state.reasonForNoPhysicalAct}
          handleFieldChange={this.handleFieldChange}
          handleParqInfo={this.handleParqInfo}
        />
      );
    } else if (step === 7) {
      renderingComponent = (
        <SignupParq2View onBack={this.setStep} state={this.state} />
      );
    } else if (step === 8) {
      renderingComponent = (
        <UnknownUserView
          onBack={this.setStep}
          onUnknownUserBack={this.onUnknownUserBack}
          email={email}
        />
      );
    }

    return renderingComponent;
  }
}

class LoginEmailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: "",
    };
    this.validateEmail = this.validateEmail.bind(this);
  }
  validateEmail(e, email) {
    e.preventDefault();
    if (/.+\@.+\..+/.test(email)) {
      this.setState((prevState) =>
        Object.assign({}, prevState, { errors: "" })
      );
      return true;
    } else {
      this.setState((prevState) =>
        Object.assign({}, prevState, { errors: "Please provide a valid email" })
      );
      return false;
    }
  }

  componentDidMount() {
    const elem = document.querySelector('input[type="email"]');
    elem.focus();
  }

  render() {
    const {
      getEmailFilled,
      handleEmailChange,
      handleEmailButton,
      redirect,
      email = "",
    } = this.props;

    return (
      <LoginWrapper
        left={
          <form method="POST" data-noreset>
            {redirect && (
              <input type="hidden" name="redirect" value={redirect} />
            )}
            <div>
              <h1>Login</h1>
            </div>

            <label htmlFor="email" data-has-error={!!this.state.errors}>
              Email
            </label>
            <div className="relative">
              <input
                type="email"
                name="email"
                value={email}
                required
                onChange={handleEmailChange}
                placeholder="Enter email here"
                data-has-error={!!this.state.errors}
                sz="large"
              />
              {this.state.errors ? <span role="input-error" /> : null}
            </div>
            <p className="error">{this.state.errors}</p>

            <button
              data-button-type="primary"
              type="submit"
              sz="large"
              onClick={(e) => {
                if (this.validateEmail(e, getEmailFilled())) {
                  handleEmailButton(e);
                }
              }}
            >
              Continue
            </button>

            <p className="login-separator hr-lines">Or, Are you a coach?</p>

            <a
              data-button-type="outline"
              role="button"
              sz="large"
              href="/signup-coach"
            >
              <span>Sign up</span>
            </a>

            <p className="terms">
              Signing up for a MyStrengthBook account means you agree to the{" "}
              <a
                href="https://mystrengthbook.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://mystrengthbook.com/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
            </p>
          </form>
        }
      />
    );
  }
}

const LoginNewOnboarding = (app) => {
  app
    .get(
      "/login",
      Auth.isLoggedOut({ redirect: "dashboard" }),
      ({ req, res, api, flash, login, locals }) => {
        if (req.query?.flashError) {
          flash("error", req.query.flashError);
          return res.refreshWith({}, { url: "/login", hash: "#_" });
        }

        return (res.body = (
          <View
            api={api}
            flash={flash}
            login={login}
            res={res}
            locals={locals}
          />
        ));
      }
    )
    .get("/login-new-onboarding/redirect/:step", async ({ req, res }) => {
      const { step } = req.params;
      const url = "/login";
      res.redirect(`${url}?step=${step}`);
    })
    .get("/user-status/:email", async ({ req, res, api, assert, locals }) => {
      const { email } = req.params;
      const { query } = req;

      assert(email, 400, "Please provide an email");
      assert(
        RegExp(
          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
        ).test(email.toLowerCase()),
        400,
        "Please provide a valid email address"
      );

      const result = await (
        await api(`user-status/${email}`, {
          method: "GET",
        })
      ).json();

      const url = "/login";
      if (result.active || result.isCoach) {
        res.redirect(`${url}?step=1`);
      } else if (result.nonExistent) {
        res.redirect(`${url}?step=8`);
      } else if (result.pendingVerification) {
        res.redirect(`${url}?step=2`);
        //if the user is an organization member
      } else if (result.pendingOrganizationVerification) {
        res.redirect(`${url}?step=2&organizationId=${result.organizationId}`);
      } else if (!result.pendingVerification) {
        if (query.step) {
          res.redirect(`${url}?step=${query.step}`);
        }
        res.redirect(`${url}?step=3`);
      }
    })
    .post("/login-refresh", async ({ res }) => {
      res.refreshWith({ step: "", reset: "" }, { url: "back" });
    })
    .post("/submit-code", async ({ req, res, api, assert, flash, session }) => {
      const { confirmCode, organizationId, email } = req.body;

      assert(confirmCode, 400, "Please enter a code");
      const result = await (
        await api("verify-code", {
          method: "POST",
          body: req.body,
        })
      ).json();
      if (result.error) {
        if (result.error.code === 400) {
          flash("error", `${result.error.message}`);
        }
      } else if (result.success) {
        sessionStorage.setItem(
          "coachSettings",
          JSON.stringify(result.coachSettings)
        );
        //if it's an organization member
        if (organizationId) {
          res.redirect(`/signup-coach-organization?email=${email}`);
        } else {
          res.redirect(`/login?step=3`);
        }
      }
    })
    .post("/resend-code", async ({ req, res, api, flash }) => {
      const result = await (
        await api("resend-code", {
          method: "POST",
          body: {
            email: req.body.email,
          },
        })
      ).json();
      if (result.error) {
        if (result.error.code === 400) {
          flash("error", `${result.error.message}`);
          res.redirect(`/login`);
        }
      } else if (result.userId) {
        flash("success", "Code resent successfully");
        res.refreshWith({ step: "2" }, { url: "back" });
      }
    })
    .post("/set-password", async ({ req: { body }, res, assert }) => {
      assert(body.password, 400, "Please provide a password");
      assert(
        body.password.length >= 6,
        400,
        "Your password must be at least 6 characters long"
      );
      assert(body.confirmPassword, 400, "Please confirm your password");
      assert(
        body.password === body.confirmPassword,
        400,
        "The passwords should match"
      );
      res.redirect(`/login?step=4`);
    })
    .post("/user-names", async ({ req: { body }, res, assert }) => {
      assert(body.first_name, 400, "Please provide a first name");
      assert(body.last_name, 400, "Please provide a last name");
      res.redirect(`/login?step=5`);
    })
    .post("/user-details", async ({ req: { body }, res, assert }) => {
      assert(body.units, 400, "Please select a measurement system");
      // Body weight validation
      body.bodyWeight &&
        assert(
          body.bodyWeight > 0,
          400,
          "Please provide a positive body weight"
        );

      // rep max Squat validation
      body.repMaxSquat &&
        assert(
          body.repMaxSquat > 0,
          400,
          "Please provide a positive squat 1 rep maximum"
        );

      // rep max bench validation
      body.repMaxBench &&
        assert(
          body.repMaxBench > 0,
          400,
          "Please provide a positive bench 1 rep maximum"
        );

      // rep max deadlift validation
      body.repMaxDeadlift &&
        assert(
          body.repMaxDeadlift > 0,
          400,
          "Please provide a positive deadlift 1 rep maximum"
        );

      body.repMaxClean &&
        assert(
          body.repMaxClean > 0,
          400,
          "Please provide a positive clean 1 rep maximum"
        );

      body.repMaxJerk &&
        assert(
          body.repMaxJerk > 0,
          400,
          "Please provide a positive jerk 1 rep maximum"
        );

      body.repMaxSnatch &&
        assert(
          body.repMaxSnatch > 0,
          400,
          "Please provide a positive snatch 1 rep maximum"
        );

      body.repMaxOverheadPress &&
        assert(
          body.repMaxOverheadPress > 0,
          400,
          "Please provide a positive overhead press 1 rep maximum"
        );

      // Terms of service validation
      assert(
        !!body.agreeTOS,
        400,
        "You must agree to the terms and conditions before continuing"
      );
      res.redirect(`/login?step=6`);
    })
    .post("/user-parq", async ({ req: { body }, res, assert }) => {
      assert(
        body.heartCondition !== undefined &&
          body.chestPain !== undefined &&
          body.pastMonthChestPain !== undefined &&
          body.dizzinesConsciousnessLoss !== undefined &&
          body.boneJointProblem !== undefined &&
          body.bloodPressurePrescription !== undefined &&
          body.reasonForNoPhysicalAct !== undefined,
        400,
        "Please fill all the options"
      );
      res.redirect(`/login?step=7`);
    })
    .post("/new-signup", async ({ req: { body }, res, assert }) => {
      res.redirect(`/login?reset=true`);
    })
    .post("/finish-onboarding", async ({ req, res, assert, api, login }) => {
      const { body, files } = req;

      body.parqForm = {
        bloodPressurePrescription: body.bloodPressurePrescription,
        boneJointProblem: body.boneJointProblem,
        chestPain: body.chestPain,
        dizzinesConsciousnessLoss: body.dizzinesConsciousnessLoss,
        heartCondition: body.heartCondition,
        pastMonthChestPain: body.pastMonthChestPain,
        reasonForNoPhysicalAct: body.reasonForNoPhysicalAct,
      };

      delete body.bloodPressurePrescription;
      delete body.boneJointProblem;
      delete body.chestPain;
      delete body.dizzinesConsciousnessLoss;
      delete body.heartCondition;
      delete body.pastMonthChestPain;
      delete body.reasonForNoPhysicalAct;

      const result = await (
        await api("finish-onboarding", {
          method: "POST",
          body,
          files,
        })
      ).json();

      if (result.error) {
        if (result.error.code === 400) {
          flash("error", `${result.error.message}`);
        }
      } else {
        const { token, userId } = await (
          await api("login", {
            method: "POST",
            body: { email: body.email, password: body.password },
          })
        ).json();

        let sessionOptions = { refresh: true, ttl: "1 day" };
        await login({ _id: userId, token }, sessionOptions);
        res.cookie("justLoggedIn", "1", { path: "/" });
        res.redirect("/dashboard/calendar/");
      }
    });
};

export default LoginNewOnboarding;
